module.exports = "/_next/static/images/5c34927a08e1ebbdefafc3ea1f25429d-box.svg.webp";